export const checkEmpty = (...args) => {
  let push = false;
  args.forEach((element) => {
    if (element === "" || 0) {
      push = true;
    }
  });
  return push;
};
